import React from 'react';
import { ReactComponent as PaymentMethodIcon } from 'assets/icons/others/payment-method-large.svg';
import defaultLocales from 'globals/locales/default';
import FsPaymentMethodForm from 'ui-elements/forms/FsPaymentMethodForm';
import FsCenterBox from 'ui-elements/common-elements/FsCenterBox';
import FsQuestionMarkContainedIcon from 'ui-elements/icons/FsQuestionMarkContained';
import FsTooltip from 'ui-elements/tooltips/FsTooltip';
import { PaymentMethodFormProps } from 'ui-elements/forms/FsPaymentMethodForm/FsPaymentMethodForm';
import { Headline, HeadlineWrapper } from './PaymentMethod.style-elements';

interface PaymentMethodProps {
  onChange: (isValid: boolean, formData?: PaymentMethodFormProps) => void;
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({ onChange }) => {
  return (
    <>
      <HeadlineWrapper>
        <FsCenterBox>
          <PaymentMethodIcon />
          <Headline>{defaultLocales.paymentMethod}</Headline>
        </FsCenterBox>
        <FsTooltip title={defaultLocales.paymentMethodTooltipInfo}>
          <FsQuestionMarkContainedIcon />
        </FsTooltip>
      </HeadlineWrapper>
      <FsPaymentMethodForm showButtons={false} onChange={onChange} />
    </>
  );
};

export default PaymentMethod;
